module.exports = __webpack_public_path__ + "media/images/athletes/3567-3d1fc8738b80924bef7237190f30c7df.png";